/*
 * @Description: 交叉分析表与卡方分析
 * @Date: 2024-01-16 14:09:19
 */
import BiTmplDetail_6 from './bi-tmpl-detail-6.vue';
export default BiTmplDetail_6;
